/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getTranslations$Json } from '../fn/translation-cdn/get-translations-json';
import { GetTranslations$Json$Params } from '../fn/translation-cdn/get-translations-json';
import { getTranslations$Plain } from '../fn/translation-cdn/get-translations-plain';
import { GetTranslations$Plain$Params } from '../fn/translation-cdn/get-translations-plain';

@Injectable({ providedIn: 'root' })
export class TranslationCdnService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTranslations()` */
  static readonly GetTranslationsPath = '/api/v1/translations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTranslations$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslations$Plain$Response(params?: GetTranslations$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getTranslations$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTranslations$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslations$Plain(params?: GetTranslations$Plain$Params, context?: HttpContext): Observable<string> {
    return this.getTranslations$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTranslations$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslations$Json$Response(params?: GetTranslations$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getTranslations$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTranslations$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTranslations$Json(params?: GetTranslations$Json$Params, context?: HttpContext): Observable<string> {
    return this.getTranslations$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
